import { render, staticRenderFns } from "./comparison.vue?vue&type=template&id=60eaffae&scoped=true&"
import script from "./comparison.vue?vue&type=script&lang=js&"
export * from "./comparison.vue?vue&type=script&lang=js&"
import style0 from "./comparison.vue?vue&type=style&index=0&id=60eaffae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eaffae",
  null
  
)

export default component.exports